import { render, staticRenderFns } from "./SelfServies.vue?vue&type=template&id=d10e06ce"
import script from "./SelfServies.vue?vue&type=script&lang=js"
export * from "./SelfServies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports